import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { baseUrl } from "../../../config/baseUrl";
import { Link } from "react-router-dom";
import buildingImg from "../../../assets/images/building_burz.png";
import loadergif from "../../../assets/images/model-loader.gif";

function AddHealthSafetyDocument({ onSuccess, show, onClose }) {
  const [docName, setDocName] = useState("");
  const [docFile, setDocFile] = useState(null);
  const [company, setCompany] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [uploadedBy, setUploadedBy] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const fileInputRef = useRef();
  const modalRef = useRef();

  useEffect(() => {
    async function fetchCompany() {
      try {
        const res = await axios.get(`${baseUrl}/get_company`, {
          headers: { Authorization: "Token " + localStorage.getItem("token") },
        });
        if (res.data && res.data.data) {
          setCompany(res.data.data.id);
          setCompanyName(res.data.data.name);
        }
      } catch (err) {
        // ignore
      }
    }
    if (show) fetchCompany();
  }, [show]);

  // Close modal on outside click or ESC
  useEffect(() => {
    if (!show) return;
    function handleClick(e) {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        onClose();
      }
    }
    function handleEsc(e) {
      if (e.key === "Escape") onClose();
    }
    document.addEventListener("mousedown", handleClick);
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [show, onClose]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const formData = new FormData();
      formData.append("name", docName);
      formData.append("helth_document", docFile);
      await axios.post(`${baseUrl}/create_college_health_document/`, formData, {
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
        },
      });
      setDocFile(null);
      setDocName("");
      if (fileInputRef.current) fileInputRef.current.value = "";
      if (onSuccess) onSuccess();
      if (onClose) onClose();
    } catch (err) {
      setError("Failed to add document.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {show && (
        <div
          className={`modal fade custom-modal addcollege-modal${
            show ? " show d-block" : ""
          }`}
          id="addHealthDocModal"
          tabIndex={-1}
          aria-labelledby="addHealthDocModalLabel"
          aria-hidden={!show}
          style={{ background: show ? "rgba(0,0,0,0.5)" : undefined }}
          data-bs-backdrop="false"
          data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-fullscreen">
            <div className="modal-content" ref={modalRef}>
              <div className="modal-header justify-content-center">
                <h5 className="modal-title">Add Health Safety Document</h5>
                <button
                  type="button"
                  className="modal-close"
                  aria-label="Close"
                  onClick={onClose}
                >
                  <i className="fa fa-times" />
                </button>
              </div>
              <div className="modal-body">
                <div className="d-flex flex-row justify-content-center align-items-center">
                  <div className="col-lg-5 text-center">
                    <div className="addbus-modal-innr">
                      <img
                        src={buildingImg}
                        width="336"
                        height="336"
                        alt="add-health-doc"
                      />
                      <form onSubmit={handleSubmit}>
                        <div className="row justify-content-center">
                          <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                            <label className="form-label">
                              Health Document Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={docName}
                              onChange={(e) => setDocName(e.target.value)}
                              required
                            />
                          </div>
                          <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                            <label className="form-label">Document File</label>
                            <input
                              type="file"
                              className="form-control"
                              ref={fileInputRef}
                              onChange={(e) => setDocFile(e.target.files[0])}
                              required
                            />
                          </div>
                          <div className="frm-bx mb-4 col-lg-8 mb-3">
                            <button
                              className="thm-btn"
                              type="submit"
                              disabled={loading}
                            >
                              {loading ? "Adding..." : "Add Document"}
                            </button>
                          </div>
                          {error && (
                            <div className="col-12 text-danger">{error}</div>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function EditHealthSafetyDocument({ show, onClose, doc, onSuccess }) {
  const [docName, setDocName] = useState(doc?.name || "");
  const [docFile, setDocFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const fileInputRef = useRef();
  const modalRef = useRef();

  useEffect(() => {
    setDocName(doc?.name || "");
    setDocFile(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  }, [doc, show]);

  // Close modal on outside click or ESC
  useEffect(() => {
    if (!show) return;
    function handleClick(e) {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        onClose();
      }
    }
    function handleEsc(e) {
      if (e.key === "Escape") onClose();
    }
    document.addEventListener("mousedown", handleClick);
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [show, onClose]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const formData = new FormData();
      formData.append("name", docName);
      if (docFile) formData.append("helth_document", docFile);
      await axios.patch(
        `${baseUrl}/update_college_health_document/${doc.id}/`,
        formData,
        {
          headers: {
            Authorization: "Token " + localStorage.getItem("token"),
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setDocFile(null);
      setDocName("");
      if (fileInputRef.current) fileInputRef.current.value = "";
      if (onSuccess) onSuccess();
      if (onClose) onClose();
    } catch (err) {
      setError("Failed to update document.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={`modal fade custom-modal addcollege-modal${
        show ? " show d-block" : ""
      }`}
      id="editHealthDocModal"
      tabIndex={-1}
      aria-labelledby="editHealthDocModalLabel"
      aria-hidden={!show}
      style={{ background: show ? "rgba(0,0,0,0.5)" : undefined }}
      data-bs-backdrop="false"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-fullscreen">
        <div className="modal-content" ref={modalRef}>
          <div className="modal-header justify-content-center">
            <h5 className="modal-title">Edit Health Safety Document</h5>
            <button
              type="button"
              className="modal-close"
              aria-label="Close"
              onClick={onClose}
            >
              <i className="fa fa-times" />
            </button>
          </div>
          <div className="modal-body">
            <div className="d-flex flex-row justify-content-center align-items-center">
              <div className="col-lg-5 text-center">
                <div className="addbus-modal-innr">
                  <img
                    src={buildingImg}
                    width="336"
                    height="336"
                    alt="edit-health-doc"
                  />
                  <form onSubmit={handleSubmit}>
                    <div className="row justify-content-center">
                      <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                        <label className="form-label">
                          Health Document Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={docName}
                          onChange={(e) => setDocName(e.target.value)}
                          required
                        />
                      </div>
                      <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                        <label className="form-label">
                          Document File (leave blank to keep existing)
                        </label>
                        {doc?.helth_document ? (
                          <div className="mb-2">
                            {/\.(png|jpe?g|gif|webp|bmp|svg)(\?.*)?$/i.test(
                              String(doc.helth_document)
                            ) ? (
                              <img
                                src={doc.helth_document}
                                alt="Current Document"
                                style={{
                                  maxWidth: "100%",
                                  height: "auto",
                                  maxHeight: 200,
                                }}
                              />
                            ) : String(doc.helth_document)
                                .toLowerCase()
                                .endsWith(".pdf") ? (
                              <iframe
                                src={doc.helth_document}
                                width="100%"
                                height="200"
                                title="Current Document"
                              />
                            ) : (
                              <a
                                href={doc.helth_document}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-info btn-sm"
                              >
                                View Uploaded document
                              </a>
                            )}
                          </div>
                        ) : null}
                        <input
                          type="file"
                          className="form-control"
                          ref={fileInputRef}
                          onChange={(e) => setDocFile(e.target.files[0])}
                        />
                      </div>
                      <div className="frm-bx mb-4 col-lg-8 mb-3">
                        <button
                          className="thm-btn"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? "Updating..." : "Update Document"}
                        </button>
                      </div>
                      {error && (
                        <div className="col-12 text-danger">{error}</div>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function DeleteHealthSafetyDocumentModal({ show, onClose, onConfirm }) {
  const modalRef = useRef();

  // Close modal on outside click or ESC
  useEffect(() => {
    if (!show) return;
    function handleClick(e) {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        onClose();
      }
    }
    function handleEsc(e) {
      if (e.key === "Escape") onClose();
    }
    document.addEventListener("mousedown", handleClick);
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [show, onClose]);

  return (
    <div
      className={`modal fade${show ? " show d-block" : ""}`}
      id="deleteHealthDocModal"
      tabIndex={-1}
      aria-labelledby="deleteHealthDocModalLabel"
      aria-hidden={!show}
      style={{ background: show ? "rgba(0,0,0,0.5)" : undefined }}
      data-bs-backdrop="false"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content" ref={modalRef}>
          <div className="modal-body">
            <div className="modal-trash">
              <img src={loadergif} alt="delete" className="w-100" />
              <h4>Are you sure you want to delete this document?</h4>
              <div className="modal-trash-btn">
                <button className="btn btn-outline-info" onClick={onClose}>
                  Cancel
                </button>
                <button className="btn btn-outline-danger" onClick={onConfirm}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function EduHealthSafetyDocumentList() {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editDoc, setEditDoc] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteDocId, setDeleteDocId] = useState(null);

  // Only allow add if cleaning_type is exactly 'College Cleaning' (trimmed)
  let cleaningType = (localStorage.getItem("cleaning_type") || "")
    .replace(/^"|"$/g, "")
    .trim();
  const canAdd = cleaningType === "College Cleaning";

  useEffect(() => {
    async function fetchDocs() {
      setLoading(true);
      setError("");
      try {
        const res = await axios.get(`${baseUrl}/get_college_health_document/`, {
          headers: { Authorization: "Token " + localStorage.getItem("token") },
        });
        if (res.data && res.data.data) {
          setDocs(res.data.data);
        } else {
          setDocs([]);
        }
      } catch (err) {
        setError("Failed to fetch health safety documents.");
        setDocs([]);
      } finally {
        setLoading(false);
      }
    }
    fetchDocs();
  }, [refresh]);

  const handleDelete = async () => {
    if (!deleteDocId) return;
    try {
      await axios.delete(
        `${baseUrl}/delete_college_health_document/${deleteDocId}/`,
        {
          headers: { Authorization: "Token " + localStorage.getItem("token") },
        }
      );
      setRefresh((r) => !r);
      setShowDeleteModal(false);
      setDeleteDocId(null);
    } catch (err) {
      // Optionally show error
      setShowDeleteModal(false);
      setDeleteDocId(null);
    }
  };

  return (
    <section className="main-sec">
      <div className="row">
        <div className="col-lg-12">
          <div className="dashboard-title">
            <h4 className="dash-head">
              <i className="fa fa-chart-bar me-2" />
              Health Safety Document List
            </h4>
          </div>
          <div className="custom-bredcump">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/education">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Health Safety Document List
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="cards bus-list">
            {canAdd && (
              <>
                <div className="d-flex flex-row justify-content-between align-items-center mb-3">
                  <div></div>
                  <button
                    className="blu-btn"
                    onClick={() => setShowAddModal(true)}
                  >
                    <i className="fa fa-plus me-2" /> Add Health Safety Document
                  </button>
                </div>
                {showAddModal && (
                  <AddHealthSafetyDocument
                    show={showAddModal}
                    onClose={() => setShowAddModal(false)}
                    onSuccess={() => {
                      setRefresh((r) => !r);
                      setShowAddModal(false);
                    }}
                  />
                )}
                {showEditModal && (
                  <EditHealthSafetyDocument
                    show={showEditModal}
                    onClose={() => setShowEditModal(false)}
                    doc={editDoc}
                    onSuccess={() => {
                      setRefresh((r) => !r);
                      setShowEditModal(false);
                    }}
                  />
                )}
                {showDeleteModal && (
                  <DeleteHealthSafetyDocumentModal
                    show={showDeleteModal}
                    onClose={() => setShowDeleteModal(false)}
                    onConfirm={handleDelete}
                  />
                )}
              </>
            )}
            <div className="table table-responsive custom-table">
              <table className="table table-borderless">
                <thead>
                  <tr>
                    <th>Sr No.</th>
                    <th>Name</th>
                    <th>Company Name</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="6">Loading...</td>
                    </tr>
                  ) : error ? (
                    <tr>
                      <td colSpan="6" className="text-danger">
                        {error}
                      </td>
                    </tr>
                  ) : docs.length > 0 ? (
                    docs.map((doc, i) => {
                      const dateObj = new Date(doc.created_at);
                      const dateStr = dateObj.toLocaleDateString();
                      const timeStr = dateObj.toLocaleTimeString();
                      return (
                        <tr key={doc.id}>
                          <td>{i + 1}</td>
                          <td>{doc.name}</td>
                          <td>{doc.company_name}</td>
                          <td>{dateStr}</td>
                          <td>{timeStr}</td>
                          <td>
                            <button
                              className="btn btn-outline-warning btn-sm me-2"
                              onClick={() => {
                                setEditDoc(doc);
                                setShowEditModal(true);
                              }}
                              title="Update"
                            >
                              <i className="fa fa-edit" />
                            </button>
                            <button
                              className="btn btn-outline-danger btn-sm"
                              onClick={() => {
                                setDeleteDocId(doc.id);
                                setShowDeleteModal(true);
                              }}
                              title="Delete"
                            >
                              <i className="fa fa-trash" />
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="6">No documents found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default EduHealthSafetyDocumentList;
export { EduHealthSafetyDocumentList };
